import { theme } from 'utils/styles';
import { ThemeProvider } from 'styled-components';
import { setupWallets, WalletProvider } from 'components/WalletContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { SettingsContextProvider } from './SettingsContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 15, // 15 seconds
      cacheTime: 1000 * 60 * 60, // 1 hours
      retry: false,
    },
  },
});

setupWallets();

const AppProviders = ({ children }: any) => {
  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <WalletProvider>
          <SettingsContextProvider>
            <div>{children}</div>
          </SettingsContextProvider>
        </WalletProvider>
      </QueryClientProvider>
      <ToastContainer
        autoClose={10000}
        position="bottom-right"
        theme="dark"
        newestOnTop
        pauseOnHover
        pauseOnFocusLoss
      />
    </ThemeProvider>
  );
};

export default AppProviders;
